import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * طلب إذن الإشعارات وتسجيل الجهاز
 * @param {Function} onSuccess - دالة تُنفذ عند نجاح التسجيل
 * @param {Function} onError - دالة تُنفذ عند حدوث خطأ
 */
export const requestNotificationPermission = async (onSuccess, onError) => {
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      if (!messaging) {
        throw new Error('لم يتم تهيئة خدمة الإشعارات بشكل صحيح');
      }
      
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      });
      
      if (currentToken) {
        console.log('تم الحصول على رمز الجهاز:', currentToken);
        if (onSuccess) onSuccess(currentToken);
        return currentToken;
      } else {
        throw new Error('لم نتمكن من الحصول على رمز الجهاز');
      }
    } else {
      throw new Error('لم يتم منح إذن الإشعارات');
    }
  } catch (error) {
    console.error('خطأ في طلب الإذن للإشعارات:', error);
    if (onError) onError(error);
    return null;
  }
};

/**
 * الاستماع للإشعارات عندما يكون التطبيق مفتوحاً
 * @param {Function} callback - دالة تُنفذ عند استلام إشعار
 */
export const listenToNotifications = (callback) => {
  if (!messaging) {
    console.warn('لم يتم تهيئة خدمة الإشعارات');
    return () => {}; // إرجاع دالة فارغة لإلغاء الاشتراك
  }
  
  return onMessage(messaging, (payload) => {
    console.log('تم استلام إشعار في المقدمة:', payload);
    
    // إنشاء إشعار محلي إذا كان التطبيق مفتوحاً
    if (Notification.permission === 'granted' && payload.notification) {
      const { title, body } = payload.notification;
      new Notification(title, { body });
    }
    
    if (callback) callback(payload);
  });
};

// الاستماع إلى الإشعارات الواردة عند عمل التطبيق - للتوافق مع الاستدعاء القديم في App.js
export const listenForMessages = () => {
  try {
    if (!messaging) {
      console.warn('لم يتم تهيئة خدمة الإشعارات، سيتم تخطي الاستماع للإشعارات');
      return () => {}; // إرجاع دالة فارغة لإلغاء الاشتراك
    }
    
    return listenToNotifications((payload) => {
      console.log('تم استلام إشعار عبر listenForMessages:', payload);
    });
  } catch (error) {
    console.error('خطأ في الاستماع للإشعارات:', error);
    return () => {}; // إرجاع دالة فارغة لإلغاء الاشتراك في حالة الخطأ
  }
};

// إرسال إشعار إلى السائق من Cloud Functions
export const sendNotification = async (recipientType, recipientId, message, fcmToken = null, orderId = null) => {
  try {
    // 1. حفظ الإشعار في قاعدة البيانات Firestore
    const notificationData = {
      recipientType,
      recipientId,
      message,
      isRead: false,
      timestamp: serverTimestamp(),
    };
    await addDoc(collection(db, "notifications"), notificationData);
    console.log('✅ تم حفظ الإشعار في قاعدة البيانات');

    // 2. إرسال إشعار FCM عبر دالة HTTPS
    if (fcmToken) {
      const response = await fetch("https://sendordernotification-f6l6kr6lva-uc.a.run.app", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          fcmToken,
          title: "طلب جديد",
          body: message,
          orderId: orderId || ""
        })
      });

      const result = await response.json();
      console.log("✅ نتيجة الإشعار من الدالة السحابية:", result);
    }

    return true;
  } catch (error) {
    console.error('❌ خطأ في إرسال الإشعار:', error);
    return false;
  }
};
